/**
 * Footer
 */
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/styles';
import React from 'react';
import {compose} from 'redux';
// intl messages
import IntlMessage from 'Util/IntlMessage.tsx';
// app config
import AppConfig from '../../config/AppConfig';
import {siteUrlAbout, siteUrlFAQ, siteUrlWhatsNew, siteUrlTerms, mailtoSupport} from '../../constants';

const styles = {
    button: {
        outline: 'none',
        textTransform: 'capitalize',
        fontWeight: 400,
    },
    root: {
        zIndex: 0,
    },
};

const Footer = ({classes}) => (
    <footer className={`${classes.root} rct-footer d-flex justify-content-between align-items-center`}>
        <ul className="list-inline footer-menus mb-0">
            <li className="list-inline-item">
                <Button className={classes.button} component='a' href={siteUrlAbout}>
                    <IntlMessage id="breadcrumbs.aboutUs" />
                </Button>
            </li>
            <li className="list-inline-item">
                <Button className={classes.button} component='a' href={siteUrlFAQ}>
                    <IntlMessage id="breadcrumbs.faq(s)" />
                </Button>
            </li>
            <li className="list-inline-item">
                <Button className={classes.button} component='a' href={siteUrlWhatsNew}>
                    <IntlMessage id="breadcrumbs.whatsNew" />
                </Button>
            </li>
            <li className="list-inline-item">
                <Button className={classes.button} component='a' href={siteUrlTerms}>
                    <IntlMessage id="breadcrumbs.terms&Conditions" />
                </Button>
            </li>
            <li className="list-inline-item">
                <Button className={classes.button} component='a' href={mailtoSupport}>
                    <IntlMessage id="breadcrumbs.feedback" />
                </Button>
            </li>
        </ul>
        <h5 className="mb-0">{AppConfig.copyRightText}</h5>
    </footer>
);

export default compose(withStyles(styles))(Footer);
